import { Button, Grid, TableFooter, Tooltip, Typography } from "@mui/material";

import { Table, TableCell, TableContainer, TableRow } from "@mui/material";

import React, { useEffect, useState } from "react";

import { enumDocumentsSource, enumPage } from "../../helpers/common.constants";
import Link from "@mui/material/Link";
import MyAlert from "../../controls/MyAlert";
import DocumentActions from "../../actions/DocumentActions";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/HighlightOff";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ArticleIcon from "@mui/icons-material/Article";
import CloudCircleIcon from "@mui/icons-material/CloudCircle";
import LogHelper from "../../helpers/LogHelper";
import { MessageHelper } from "../../helpers/MessageHelper";
import ManageFolder from "./ManageFolder";
import MyDialog from "../../controls/MyDialog";
import UploadFile from "./UploadFile";
import DeleteFileFolder from "./DeleteFileFolder";
import { useParams } from "react-router-dom";
import { DocumentService } from "../../services/DocumentService";
import UploadMultipleFile from "./UploadMultipleFile";
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';

export default function DocumentPicker(args) {
  const [MessageData, setMessageData] = useState({});
  const [RecordsAll, setRecordsAll] = useState([]);
  const [RecordsParentFolderNames, setRecordsParentFolderNames] = useState([]);
  const [RecordsParentFolderIDs, setRecordsParentFolderIDs] = useState([]);
  const [ParentFolderId, setParentFolderId] = useState([]);
  const [ParentFolderName, setParentFolderName] = useState([]);
  const [RootFolderId, setRootFolderId] = useState([]);
  const [FolderId, setFolderId] = useState([]);
  const [FolderName, setFolderName] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [ModalParams, setModalParams] = useState({
    ShowModal: false,
    Content: "",
    OnModalClose: null,
    OnModalHasChanges: null,
    Title: "",
  }); //ModalParams e objekt koj sto IsOpen i IsContent ima struktura

  //za poraki pri loadiranje na strana
  const msgHelper = new MessageHelper();

  useEffect(() => {
    if (args.InputFolderID) {
      initData();
    }
    return () => { };
  }, [args.InputFolderID]);

  const openUploadFileDialog = () => {
    let args = { FolderId: FolderId, FolderName: FolderName, IsFolder: true };
    let control = <UploadFile {...args} />;
    setModalParams({
      ShowModal: true,
      Content: control,
      OnModalClose: onModalCloseNewFolder,
    });
  };


  const openUploadMultipleFileDialog = () => {
    let args = { FolderId: FolderId, FolderName: FolderName, IsFolder: true };
    let control = (
      <UploadMultipleFile {...args} />
    );

    setModalParams({
      ShowModal: true,
      Content: control,
      OnModalClose: onModalCloseNewFolder,
    });
  };

  const openGoogleDriveDialog = () => {
    let url = "https://drive.google.com/drive/u/2/folders/" + FolderId;
    window.open(url, "_blank");
  };



  const closeDocumentPickerWindow = () => {
    //isprati gi fajlovite prema MyDocumentPicker
    args.OnModalClose({ SelectedFiles: selectedFiles });
  };

  function onModalCloseNewFolder(args) {
    setModalParams({ ShowModal: false, Content: null });
    if (args.HasChanges) {
      GetContentData(RootFolderId, args.FolderId);
    }
  }

  const initData = () => {
    async function fetchData() {
      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      setRootFolderId(args.InputFolderID);
      GetContentData(args.InputFolderID, args.InputFolderID);

      if (args.SelectedFiles) {
        setSelectedFiles(args.SelectedFiles);
      }
    };
    fetchData();
  }

  const GetContentData = (rootFolderId, folderId) => {
    //alert("CALLED");
    async function fetchData() {
      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      setRecordsAll([]);
      setRecordsParentFolderIDs([]);
      setRecordsParentFolderNames([]);
      setRecordsParentFolderIDs([]);

      let responses =
        await new DocumentActions().GetFolderContentByFolderIdAsync(
          rootFolderId,
          folderId
        );
      if (!responses.error) {
        const rootRecord = responses[0].data;
        setRecordsAll(rootRecord.files);

        let pathParentFolderNames = rootRecord.pathParentFolderNames.split(",");
        let pathParentFolderIDs = rootRecord.pathParentFolderIDs.split(",");
        setRecordsParentFolderNames(pathParentFolderNames);
        setRecordsParentFolderIDs(pathParentFolderIDs);

        //najvazno za MODAL da raboti so toj FolderId i FolderName
        setFolderId(rootRecord.folderId);
        setFolderName(rootRecord.folderName);

        //Ovoj del mu treba pri brisenje na Folder da moze da se vrati na eden folder prethodno
        if (rootRecord.parent) {
          setParentFolderId(rootRecord.parent.folderId);
          setParentFolderName(rootRecord.parent.folderName);
        }

        //Load Finished
        result = msgHelper.setPhase(enumPage.LoadSuccess);
        setMessageData(result);
      } else {
        setMessageData({
          HasError: true,
          Message: responses.error_description,
        });
      }
    }

    fetchData();
  };


  const StoreInBagFile = (row, forceDelete) => {

    //proveri prvo dali go ima vo kolekcija togas izbrisi go 
    let isSelected = !row.isChecked;
    let newSelectedFiles = selectedFiles;
    if (!isSelected || forceDelete) {
      newSelectedFiles = newSelectedFiles.filter(a => a.fileId !== row.fileId);
      let result = msgHelper.setPhase(enumPage.ActionSuccessWithMsg, "", "File removed:" + row.fileName);
      setMessageData(result);
    }
    else {
      newSelectedFiles.push(row);
      let result = msgHelper.setPhase(enumPage.ActionSuccessWithMsg, "", "File selected:" + row.fileName);
      setMessageData(result);
    }
    setSelectedFiles(newSelectedFiles);


    //sega najdi go RowId od Tree-to i stikliraj
    let newRecordsAll = [...RecordsAll];
    let currentRecord = newRecordsAll.find(a => a.fileId == row.fileId);
    let currentIndex = newRecordsAll.findIndex(a => a.fileId == row.fileId);
    currentRecord.isChecked = isSelected;
    newRecordsAll[currentIndex] = currentRecord;
    setRecordsAll(newRecordsAll);
  };


  const StoreInBagFolder = (row, forceDelete) => {

    //proveri prvo dali go ima vo kolekcija togas izbrisi go 
    let isSelected = !row.isChecked;
    let newSelectedFiles = selectedFiles;
    if (!isSelected || forceDelete) {
      newSelectedFiles = newSelectedFiles.filter(a => a.folderId !== row.folderId);
      let result = msgHelper.setPhase(enumPage.ActionSuccessWithMsg, "", "Folder removed:" + row.folderName);
      setMessageData(result);
    }
    else {
      newSelectedFiles.push(row);
      let result = msgHelper.setPhase(enumPage.ActionSuccessWithMsg, "", "Folder selected:" + row.folderName);
      setMessageData(result);
    }
    setSelectedFiles(newSelectedFiles);


    //sega najdi go RowId od Tree-to i stikliraj
    let newRecordsAll = [...RecordsAll];
    let currentRecord = newRecordsAll.find(a => a.folderId == row.folderId);
    let currentIndex = newRecordsAll.findIndex(a => a.folderId == row.folderId);
    currentRecord.isChecked = isSelected;
    newRecordsAll[currentIndex] = currentRecord;
    setRecordsAll(newRecordsAll);
  };

  const downloadFile = (fileName, fileId) => {
    async function fetchData() {
      let payload = "/" + fileId;
      let response = await new DocumentActions().DownloadFileAsync(payload);

      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    }
    fetchData();
  };

  const getFolderFileName = (row) => {
    if (row.isFolder)
      return (
        <div>
          <input type="checkbox" checked={row.isChecked} onClick={() => StoreInBagFolder(row, false)} />
          <Link
            onClick={() => GetContentData(RootFolderId, row.folderId)}
            href="#"
            underline="none"
            rel="noopener noreferrer"
          >
            <FolderIcon sx={{ fontSize: 15 }} /> &nbsp;{row.folderName}
          </Link>
        </div>
      );
    else return (
      <div>
        <input type="checkbox" checked={row.isChecked} onClick={() => StoreInBagFile(row, false)} />
        <Link
          onClick={() => downloadFile(row.fileName, row.fileId)}
          href="#"
          underline="none"
          rel="noopener noreferrer"
        >
          <ArticleIcon sx={{ fontSize: 15 }} /> &nbsp;{row.fileName}
        </Link>
      </div>);
  };

  const selectedFolderFileName = (row, showSeparator) => {
    if (row.isFolder)
      return (
        <React.Fragment>
          <Link

            fontSize={13}
            href="#"
            underline="none"
            rel="noopener noreferrer"

          >
            {showSeparator ? "," : "Selected: "} {row.folderName} <DeleteIcon style={{ fontSize: 13 }} onClick={() => StoreInBagFolder(row, true)} />
          </Link>
        </React.Fragment>
      );
    else return (
      <React.Fragment>
        <Link
          sx={{ position: 'relative', top: '5px' }}
          fontSize={13}
          href="#"
          underline="none"
          rel="noopener noreferrer"

        >
          {showSeparator ? "," : ""}  {row.fileName} <DeleteIcon style={{ fontSize: 13 }} onClick={() => StoreInBagFile(row, true)} />
        </Link>
      </React.Fragment>
    );
  };

  const HeaderButtons = () => {
    return (
      <Grid
        container
        sx={{ borderBottom: 1, borderColor: "grey.500", pb: 1 }}
        align="center"
      >
        <Grid item xs={12} spacing={1}>
          <Button
            sx={{ mr: 2 }}
            variant="contained"
            startIcon={<UploadFileIcon />}
            size="small"
            color="success"
            onClick={() => openUploadFileDialog()}
          >
            Upload File
          </Button>

          {/* <Button
            sx={{ mr: 2 }}
            variant="contained"
            startIcon={<UploadFileIcon />}
            size="small"
            color="success"
            onClick={() => openUploadMultipleFileDialog()}
          >
            Upload Multiple File
          </Button> */}

          <Button
            sx={{ mr: 2 }}
            variant="contained"
            startIcon={<CloudCircleIcon />}
            size="small"
            onClick={() => openGoogleDriveDialog()}
          >
            Go To Drive
          </Button>

          <Button
            sx={{ mr: 2 }}
            variant="contained"
            startIcon={<CancelPresentationIcon />}
            size="small"
            color="info"
            onClick={() => closeDocumentPickerWindow()}
          >
            Close
          </Button>
        </Grid>
        <Grid item xs={12} spacing={1}>
          {selectedFiles.map((row, index) => (selectedFolderFileName(row, index !== 0)))}
        </Grid>
      </Grid>
    );
  };

  return (
    <Typography sx={{ my: 0, mx: 1 }} color="text.secondary" align="left">
      <MyAlert {...MessageData} />

      <HeaderButtons />

      <TableContainer
        sx={{ border: 0, display: { xs: "block", sm: "block", md: "block" } }}
      >
        <Table size="small" aria-label="a dense table"
        >

          <TableRow >
            <TableCell>
              {RecordsParentFolderNames.map((folderName, index) => (
                <Link
                  href="#"
                  onClick={() =>
                    GetContentData(RootFolderId, RecordsParentFolderIDs[index])
                  }
                  underline="none"
                  rel="noopener noreferrer"
                >
                  {folderName}
                  {index + 1 !== RecordsParentFolderIDs.length && " > "}
                </Link>
              ))}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <b> Name</b>
            </TableCell>
          </TableRow>

          {RecordsAll.map((row, index) => (
            <TableRow>
              <TableCell sx={{ paddingTop: 0.2, paddingBottom: 0.2 }}>
                {getFolderFileName(row)}
              </TableCell>
            </TableRow>
          ))}
        </Table>

      </TableContainer>

      <MyDialog
        IsOpen={ModalParams.ShowModal}
        HandleModalClose={ModalParams.OnModalClose}
        Title={ModalParams.Title}
        Content={ModalParams.Content}
      />
    </Typography>
  );
}
